import {Injectable} from '@angular/core';
import {DcpDataService} from '../dcp-data.service';
import {EddlAdobeTrackingData} from './models/eddl-adobe-tracking-data';
import {CxEvent} from '@spartacus/core';
import {EddlLogoutEvent} from './events/eddl-logout-event';

@Injectable({
  providedIn: 'root',
})
export class DcpEddlLogoutDataService extends DcpDataService<EddlAdobeTrackingData> {
  constructor() {
    super();
  }

  fillData(event: EddlLogoutEvent, data?: EddlAdobeTrackingData): EddlAdobeTrackingData {
    if (!data) {
      data = {};
    }
    if (!data.user) {
      data.user = {};
    }
    data.event = 'userLogout';
    data.user.loginStatus = 'no';
    return data;
  }

  getData(event: CxEvent): EddlAdobeTrackingData {
    if (!(event instanceof EddlLogoutEvent)) {
      return undefined;
    }
    return this.fillData(event);
  }
}
